// the most terrible camelizer on the internet, guaranteed!
export default str =>
  `${str
    .charAt(0)
    .toLowerCase()}${str
    .replace(/[\W_]/g, '|')
    .split('|')
    .map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
    .join('')
    .slice(1)}`;

// toCamelCase(str) {
//   return str.toString() && str.split(' ').map((word, index) => {
//     return (index === 0 ? word[0].toLowerCase() : word[0].toUpperCase()) + word.slice(1).toLowerCase()
//   }).join('')